export const danceCollectionTypes = [
    'top_hits',
    'release_batch',
    'course',
    'contest',
]
